import { render } from "./ControllerCard.vue?vue&type=template&id=44c6fc64"
import script from "./ControllerCard.vue?vue&type=script&lang=js"
export * from "./ControllerCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__